<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4">
          <v-btn class="mr-2" fab x-small color="primary" @click="$router.back()">
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn>Edit User
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete ref="rank" outlined v-model="form.rank" :items="ranks" item-text="text" item-value="value" label="Rank *" append-icon="mdi-account" :error-messages="errors.rank"></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch v-model="form.active" inset :label="`Is Active: ${form.active == 1 ? 'YES' : 'NO'
            }`"></v-switch>
            </v-col>
            <v-col sm="4">
              <v-checkbox v-model="form.is_pre_join" label="Pre-Join Candidate"
                hint="Only sees pre-join courses on portal login" persistent-hint>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4">
              <v-text-field v-model="form.name" outlined label="Given Name *" prepend-inner-icon="mdi-buffet"
                :error-messages="errors && errors.name"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.last_name" outlined label="Surname Name *" prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-menu v-model="dob_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field outlined v-model="form.dob" label="Date Of Birth *" append-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on" clearable @click:clear="dob = null"
                    :error-messages="errors.dob"></v-text-field>
                </template>
                <v-date-picker :id="`dob`" v-model="form.dob" @change="dob_menu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-autocomplete ref="placeofbirth" outlined v-model="form.place_of_birth" :items="birth_places"
                label="Place of Birth *" append-icon="mdi-account"
                :error-messages="errors.place_of_birth"></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete ref="nationality" outlined v-model="form.nationality" :items="nationalities"
                label="Nationality *" append-icon="mdi-account" :error-messages="errors.nationality"></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete ref="gender" outlined v-model="form.gender" :items="genders" label="gender *"
                append-icon="mdi-account" :error-messages="errors.gender"></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.phone" outlined label="Mobile no *" prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.whatsapp_no" outlined label="Whatsapp no *" prepend-inner-icon="mdi-phone"
                :error-messages="errors.whatsapp_no"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.email" outlined label="Email *" prepend-inner-icon="mdi-email"
                :error-messages="errors.email"></v-text-field>
            </v-col>
            <v-col sm="4">
              <b>Upload Image</b>
              <br>
              <input type="file" id="file_0" name="file_0" ref="file_0" accept="image/*" @change="imagepath" />

              <template v-if="form.image_path != null">
                <v-img class="mt-2" v-if="form.image_path != null" :src="mediaUrl + form.image_path" alt="image 1"
                  style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_0.value = null), (form.image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
            <v-col sm="4">
              <b>Upload Signature Image</b>
              <br>
              <input type="file" id="file_7" name="file_7" ref="file_7" accept="image/*" />

              <template v-if="form && form.signature_image_path != null">
                <v-img class="mt-2" v-if="form.signature_image_path != null" :src="mediaUrl + form.signature_image_path"
                  alt="image 1" style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.signature_image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_7.value = null), (form.signature_image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <h2>Other Details</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4">
              <v-text-field v-model="form.passport_no" outlined label="PASSPORT NO."
                prepend-inner-icon="mdi-bank"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.cdc" outlined label="CDC NO. *" prepend-inner-icon="mdi-bank"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.coc" outlined label="COC NO." prepend-inner-icon="mdi-bank"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.sid" outlined label="SID NO." prepend-inner-icon="mdi-buffet"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.indos" outlined label="INDOS NO." prepend-inner-icon="mdi-buffet"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.age" outlined label="Age" prepend-inner-icon="mdi-calendar"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.contract_expiry" outlined label="Contract Expiry" prepend-inner-icon="mdi-calendar-clock"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.on_board_since" outlined label="On Board Since" prepend-inner-icon="mdi-ship-wheel"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete outlined ref="vessel" v-model="form.vessel_id" :items="vessels" 
                item-text="text" item-value="value" label="Vessel" 
                append-icon="mdi-ferry" :error-messages="errors.vessel_id"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <h2>Uploads</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4">
              <b>PASSPORT IMAGE <span class="error--text">*</span></b>
              <br>
              <input type="file" id="file_1" name="file_1" ref="file_1" accept="image/*" @change="PassportImagePath" />

              <template v-if="form && form.passport_image_path != null">
                <v-img class="mt-2" v-if="form.passport_image_path != null" :src="mediaUrl + form.passport_image_path"
                  alt="image 1" style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.passport_image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_1.value = null), (form.passport_image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
            <v-col sm="4">
              <b>CDC NO. <span class="error--text">*</span></b>
              <br>
              <input type="file" id="file_2" name="file_2" ref="file_2" accept="image/*" @change="CDCImagePath" />

              <template v-if="form && form.cdc_image_path != null">
                <v-img class="mt-2" v-if="form.cdc_image_path != null" :src="mediaUrl + form.cdc_image_path"
                  alt="image 1" style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.cdc_image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_2.value = null), (form.cdc_image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
            <v-col sm="4">
              <b>SID NO. <span class="error--text">*</span></b>
              <br>
              <input type="file" id="file_3" name="file_3" ref="file_3" accept="image/*" @change="SiDImagePath" />

              <template v-if="form && form.sid_image_path != null">
                <v-img class="mt-2" v-if="form.sid_image_path != null" :src="mediaUrl + form.sid_image_path"
                  alt="image 1" style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.sid_image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_3.value = null), (form.sid_image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
            <v-col sm="4">
              <b>COC NO. <span class="error--text">*</span></b>
              <br>
              <input type="file" id="file_4" name="file_4" ref="file_4" accept="image/*" @change="CocImagePath" />

              <template v-if="form && form.coc_image_path != null">
                <v-img class="mt-2" v-if="form.coc_image_path != null" :src="mediaUrl + form.coc_image_path"
                  alt="image 1" style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.coc_image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_4.value = null), (form.coc_image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
            <v-col sm="4">
              <b>WATCHKEEPING</b>
              <br>
              <input type="file" id="file_5" name="file_5" ref="file_5" accept="image/*"
                @change="WatchkeepingImagePath" />

              <template v-if="form && form.watch_keeping_image_path != null">
                <v-img class="mt-2" v-if="form.watch_keeping_image_path != null"
                  :src="mediaUrl + form.watch_keeping_image_path" alt="image 1"
                  style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.watch_keeping_image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_5.value = null), (form.watch_keeping_image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
            <v-col sm="4">
              <b>COP</b>
              <br>
              <input type="file" id="file_6" name="file_6" ref="file_6" accept="image/*" @change="COPImagePath" />

              <template v-if="form && form.cop_image_path != null">
                <v-img class="mt-2" v-if="form.cop_image_path != null" :src="mediaUrl + form.cop_image_path"
                  alt="image 1" style="height: 50%; width: 50% !important" />
                <br>
                <v-btn x-small class="mx-2" :href="`${mediaUrl}${form.cop_image_path}`" target="_blank"
                  color="primary">View</v-btn>
                <v-btn x-small class="reset_image my-1" color="red" dark @click="
            ($refs.file_6.value = null), (form.cop_image_path = null)
            ">Remove</v-btn>
              </template>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col sm="4">
              <h2 style="margin-bottom: 8px;">Company Details</h2>
              <v-autocomplete outlined ref="company" v-model="form.org_id" :items="companies" label="Select Company *" item-text="text" item-value="value" prepend-inner-icon="mdi-account" :error-messages="errors.companies"></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="roleName && (roleName == 'ADMIN' || roleName == 'SUPER ADMIN' || roleName == 'MANAGER')">
              <h2 class="text-start" style="margin-bottom: 8px;">Assign Teacher</h2>
              <v-autocomplete outlined ref="teacher" v-model="form.assign_teacher_id" :items="teachers" item-text="text" item-value="value" label="Select Teacher *" prepend-inner-icon="mdi-account" :error-messages="errors.assign_teacher_id"></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="12" mt="4">
              <h2>Assign Course</h2>
              <v-btn class="mt-4" @click="addRow" color="primary" small>Add Row</v-btn>
              <v-btn
                v-if="canResetAttempts && hasLockedOutCourses"
                class="mt-4 ml-2"
                color="warning"
                small
                :loading="isBulkResetting"
                @click="askBulkReset"
              >
                <v-icon left small>mdi-restart</v-icon> Reset All Expired/Locked Courses
              </v-btn>
              <v-row class="mt-4" v-for="(course, index) in   courserow  " :key="index">
                <v-col sm="6" md="3" lg="3">
                  <v-autocomplete :items="courses" :disabled="course.is_assigned" label="Select Course" item-text="text" item-value="value" v-model="course.course_id" :error-messages="errors[`courses.${index}.course_id`]"></v-autocomplete>
                </v-col>
                <v-col sm="6" md="3" lg="3">
                  <v-autocomplete :items="duration" label="Select Duration" item-text="text" item-value="value" v-model="course.course_duration" :error-messages="errors[`courses.${index}.duration`]"></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-menu v-if="course.is_completed == true" v-model="course.start_date_menu"
                    :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y
                    min-width="auto">

                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="new Date(course.created_at).toISOString().split('T')[0]" label="Issue Date"
                        prepend-icon="mdi-calendar" readonly clearable v-bind="attrs" v-on="on"
                        @click:clear="created_at = null"></v-text-field>
                    </template>
                    <v-date-picker v-model="course.created_at" @change="course.start_date_menu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col sm="6" md="3" lg="3" v-if="course.id && canResetAttempts && isLockedOut(course)"
                  class="d-flex align-center">
                  <v-btn small color="warning" :loading="resettingId === course.id"
                    :disabled="resettingId === course.id" @click="askReset(course)">
                    <v-icon left small>mdi-restart</v-icon> Reset Attempts
                  </v-btn>
                </v-col>
                <v-col sm="6" md="3" lg="3" v-if="course.id && canMarkComplete && !course.is_completed"
                  class="d-flex align-center">
                  <v-btn small color="success" :loading="markingId === course.id"
                    :disabled="markingId === course.id" @click="askMark(course)">
                    <v-icon left small>mdi-check-bold</v-icon> Mark as Completed
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-card-text>
              <v-divider class="mt-5 mb-5"> </v-divider>
              <v-progress-circular style="float: right;" v-if="isLoading" indeterminate
                color="primary"></v-progress-circular>
              <v-btn style="float: right;" v-else :loading="isLoading" :disable="isLoading" color="primary" dark
                @click="save">
                Update Candidate </v-btn>
              <v-btn v-if="form.is_approved == true"
                style="float: right; margin-right: 19px; font-size: 11px; width: 140px;" color="green" dark
                :loading="isLoading" :disable="isLoading">
                Approved</v-btn>
              <v-btn v-else-if="form.is_approved == false"
                style="float: right; margin-right: 19px; font-size: 11px; width: 140px;" color="green" dark
                :loading="isLoading" :disable="isLoading" @click="approved">
                Approve Candidate </v-btn>
            </v-card-text>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Reset attempts confirmation -->
      <v-dialog v-model="resetDialog" max-width="440">
        <v-card>
          <v-card-title class="headline">Reset attempts?</v-card-title>
          <v-card-text>
            This gives the candidate a fresh set of attempts for this course, clears any completion and
            certificate, and unlocks the exam. Past exam records are kept for history.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="resetDialog = false" :disabled="isResetting">Cancel</v-btn>
            <v-btn color="warning" :loading="isResetting" @click="confirmReset">Reset</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Mark as completed confirmation -->
      <v-dialog v-model="markDialog" max-width="440">
        <v-card>
          <v-card-title class="headline">Mark as completed?</v-card-title>
          <v-card-text>
            This marks the course as <strong>completed</strong> for this candidate and generates their
            certificate. The candidate will then be able to download it.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="markDialog = false" :disabled="isMarking">Cancel</v-btn>
            <v-btn color="success" :loading="isMarking" @click="confirmMark">Mark Completed</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Bulk reset confirmation -->
      <v-dialog v-model="bulkResetDialog" max-width="440">
        <v-card>
          <v-card-title class="headline">Reset all expired/locked courses?</v-card-title>
          <v-card-text>
            This gives this candidate a fresh set of attempts for every course that is currently
            <strong>expired</strong> or has <strong>no attempts left</strong> (and not already completed),
            clears any completion/certificate on those, and unlocks the exams. Past exam records are kept
            for history.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="bulkResetDialog = false" :disabled="isBulkResetting">Cancel</v-btn>
            <v-btn color="warning" :loading="isBulkResetting" @click="confirmBulkReset">Reset All</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios-offline";
import UserService from "@/services/user-service";

export default {
  name: "UserEditPage",
  data() {
    return {
      form: {
        active: true,
        rank: "", // Initialize rank field
      },
      companies: [],
      dob_menu: false,
      start_date_menu: false,
      roles: [
        {
          id: 0,
          text: "Select Role",
          value: "",
        },
      ],
      // mediaUrl is provided by the global mixin from Vuex store (settings/getMediaUrl)
      errors: {}, // Add errors property
      ranks: [],
      teachers: [],
      nationalities: [],
      birth_places: [],
      vessels: [],
      courses: [],
      genders: [
        { text: "Male", value: "Male" },
        { text: "Female", value: "Female" },
      ],
      duration: [],
      subjects: [],
      image_path: "",
      passport_image_path: "",
      cdc_image_path: "",
      sid_image_path: "",
      coc_image_path: "",
      watchkeeping_image_path: "",
      cop_image_path: "",
      courserow: [],
      rows: [],
      isLoading: false,
      is_approved_profile: false,
      // Reset attempts
      resetDialog: false,
      resetTarget: null,
      isResetting: false,
      resettingId: null,
      // Mark as completed
      markDialog: false,
      markTarget: null,
      isMarking: false,
      markingId: null,
      // Bulk reset (all expired/locked courses for this candidate)
      bulkResetDialog: false,
      isBulkResetting: false,
    };
  },
  mounted() {
    console.log('User ID from route params:', this.$route.params.userId);
    this.getMasters().then(() => {
      this.getData();
    });
  },
  methods: {
    // Locked out = exhausted all attempts (0 remaining) OR expired by date,
    // without passing. parseInt guards against blank/null being treated as 0
    // by loose equality.
    isLockedOut(course) {
      return (
        course &&
        !course.is_completed &&
        (parseInt(course.no_of_attempt) === 0 || !!course.is_expired)
      );
    },
    askReset(course) {
      this.resetTarget = course;
      this.resetDialog = true;
    },
    async confirmReset() {
      if (!this.resetTarget) return;
      const id = this.resetTarget.id; // course_candidate id
      if (!id) {
        alert("Please save the candidate first, then reset attempts.");
        this.resetDialog = false;
        return;
      }
      this.isResetting = true;
      this.resettingId = id;
      try {
        await axios.post(`course_candidates/${id}/reset-attempts`);
        this.resetDialog = false;
        this.resetTarget = null;
        await this.getData();
      } catch (e) {
        console.error("Reset attempts failed:", e);
        alert("Failed to reset attempts. Please try again.");
      } finally {
        this.isResetting = false;
        this.resettingId = null;
      }
    },
    askMark(course) {
      this.markTarget = course;
      this.markDialog = true;
    },
    async confirmMark() {
      if (!this.markTarget) return;
      const id = this.markTarget.id; // course_candidate id
      if (!id) {
        alert("Please save the candidate first, then mark completed.");
        this.markDialog = false;
        return;
      }
      this.isMarking = true;
      this.markingId = id;
      try {
        await axios.post(`course_candidates/${id}/mark-complete`);
        this.markDialog = false;
        this.markTarget = null;
        await this.getData();
      } catch (e) {
        console.error("Mark completed failed:", e);
        alert("Failed to mark completed. Please try again.");
      } finally {
        this.isMarking = false;
        this.markingId = null;
      }
    },
    askBulkReset() {
      this.bulkResetDialog = true;
    },
    async confirmBulkReset() {
      const candidateId = this.form.id || this.$route.params.userId;
      if (!candidateId) {
        alert("Please save the candidate first, then reset attempts.");
        this.bulkResetDialog = false;
        return;
      }
      this.isBulkResetting = true;
      try {
        const response = await axios.post("course_candidates/bulk-reset-attempts", {
          candidate_id: candidateId,
        });
        this.bulkResetDialog = false;
        const resetCount = response.data && response.data.reset;
        if (resetCount != null) {
          alert(`Reset attempts for ${resetCount} course(s).`);
        }
        await this.getData();
      } catch (e) {
        console.error("Bulk reset attempts failed:", e);
        alert("Failed to reset attempts. Please try again.");
      } finally {
        this.isBulkResetting = false;
      }
    },
    addRow() {
      // Add a new row with default values
      this.courserow.push({
        course_id: null,
        course_duration: null,
        created_at: null,
        is_completed: false,
        is_assigned: false,
        start_date_menu: false
      });
    },
    async getMasters() {
      try {
        console.log('Loading masters data...');
        let response = await axios.get(`users/masters`);
        let masters = response.data?.data || response.data || {};

        // Reset arrays to avoid duplicates
        this.ranks = [];
        this.courses = [];
        this.companies = [];
        this.nationalities = [];
        this.birth_places = [];
        this.vessels = [];
        this.duration = [];
        this.teachers = [];

        // Defensive coding with null checks and fallbacks
        if (masters.ranks && Array.isArray(masters.ranks)) {
          this.ranks = masters.ranks.map(rank => ({
            text: rank.description,
            value: rank.description,
          }));
          console.log('Ranks loaded:', this.ranks.length);
        }

        if (masters.courses && Array.isArray(masters.courses)) {
          this.courses = masters.courses.map(course => ({
            text: course.name,
            value: course.id,
          }));
          console.log('Courses loaded:', this.courses.length);
        }

        if (masters.companies && Array.isArray(masters.companies)) {
          this.companies = masters.companies.map(company => ({
            text: company.name,
            value: company.id,
          }));
          console.log('Companies loaded:', this.companies.length);
        }

        if (masters.nationality && Array.isArray(masters.nationality)) {
          this.nationalities = masters.nationality.map(nationality => ({
            text: nationality.description,
            value: nationality.description
          }));
          console.log('Nationalities loaded:', this.nationalities.length);
        }

        if (masters.birth_place && Array.isArray(masters.birth_place)) {
          this.birth_places = masters.birth_place.map(birth_place => ({
            text: birth_place.description,
            value: birth_place.description
          }));
          console.log('Birth places loaded:', this.birth_places.length);
        }

        if (masters.duration && Array.isArray(masters.duration)) {
          this.duration = masters.duration.map(duration => ({
            text: duration.description,
            value: duration.description
          }));
          console.log('Durations loaded:', this.duration.length);
        }

        // Handle vessels data
        if (masters.vessels && Array.isArray(masters.vessels)) {
          this.vessels = masters.vessels.map(vessel => ({
            text: vessel.description,
            value: vessel.id,
          }));
          console.log('Vessels loaded:', this.vessels.length);
        }

        // Handle teachers data
        if (masters.teachers && Array.isArray(masters.teachers)) {
          this.teachers = masters.teachers.map(teacher => ({
            text: teacher.name,
            value: teacher.id,
          }));
          console.log('Teachers loaded:', this.teachers.length);
        }

        console.log('All masters data loaded successfully');
      } catch (error) {
        console.error('Error loading masters data:', error);
        // Set empty arrays as fallback
        this.ranks = [];
        this.courses = [];
        this.companies = [];
        this.nationalities = [];
        this.birth_places = [];
        this.vessels = [];
        this.duration = [];
        this.teachers = [];
        this.$toast.error('Failed to load dropdown data. Please try again.');
      }
    },
    async getData() {
      try {
        console.log('Fetching user data for ID:', this.$route.params.userId);
        this.isLoading = true;
        let response = await axios.get(`/users/${this.$route.params.userId}`);
        console.log('API Response:', response);
        
        // Check if response is successful
        if (!response.data.success) {
          console.error('API returned unsuccessful response:', response.data.message);
          this.form = {};
          this.courserow = [];
          return;
        }
        
        this.form = response.data?.data || response.data || {};
        console.log('User data loaded:', this.form);
        console.log('User rank:', this.form.rank);
        
        // Defensive coding for course_candidates
        // Map course_candidates data to the format expected by the template
        if (this.form.course_candidates && Array.isArray(this.form.course_candidates)) {
          this.courserow = this.form.course_candidates.map(course => ({
            id: course.id, // course_candidate id (needed for reset-attempts)
            course_id: course.course_id,
            course_duration: course.course_duration,
            created_at: course.created_at,
            is_completed: course.is_completed,
            is_assigned: course.is_assigned,
            is_expired: course.is_expired,
            no_of_attempt: course.no_of_attempt,
            start_date_menu: false
          }));
          console.log('Mapped course candidates:', this.courserow);
        } else {
          this.courserow = [];
          console.log('No course candidates found');
        }
        
        // Log courses and duration data for debugging
        console.log('Available courses:', this.courses);
        console.log('Available durations:', this.duration);
        
        // Safe role assignment with null checks
        if (this.form.roles && Array.isArray(this.form.roles) && this.form.roles.length > 0) {
          this.form.role_id = this.form.roles[0]?.id || "";
        } else {
          this.form.role_id = "";
        }
      } catch (error) {
        console.error('Error loading user data:', error.response?.data || error.message || error);
        // this.$toast.error('Failed to load user data. Please try again.');
        this.form = {};
        this.courserow = [];
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      // Validate required fields before saving
      this.errors = {};
      let hasErrors = false;

      const name = this.form.name ? String(this.form.name).trim() : '';
      const lastName = this.form.last_name ? String(this.form.last_name).trim() : '';
      const rank = this.form.rank ? String(this.form.rank).trim() : '';

      if (!name) {
        this.errors.name = 'Given Name is required';
        hasErrors = true;
      }
      if (!lastName) {
        this.errors.last_name = 'Surname is required';
        hasErrors = true;
      }
      if (!rank) {
        this.errors.rank = 'Rank is required';
        hasErrors = true;
      }

      if (hasErrors) {
        this.$toast.error('Please fill in all required fields');
        // Scroll to top to show errors
        window.scrollTo(0, 0);
        return;
      }

      try {
        this.isLoading = true;
        this.isLoadingApprove = true;
        // Only send courses if courserow has valid data to avoid backend validation errors
        if (this.courserow.length > 0 && this.courserow.every(row => row.course_id && row.course_duration)) {
          this.form.courses = this.courserow.map(row => ({
            course_id: row.course_id,
            duration: row.course_duration,
            created_at: row.created_at,
            is_completed: row.is_completed,
          }));
        } else {
          delete this.form.courses;
        }
        
        // Use UserService for updating candidates
        let response = await UserService.createUser(this.form);
        
        this.form = response.data || response;
        await this.handleFileUpload();
        this.isLoading = false;
        this.isLoadingApprove = false;
        // this.$toast.success('User updated successfully!');
        this.$router.push("/users");
      } catch (error) {
        console.error("Error updating candidate:", error.response?.data || error.message || error);
        // this.$toast.error('Failed to update user. Please try again.');
        this.isLoading = false;
        this.isLoadingApprove = false;
      }
    },
    approved() {
      this.form.is_approved_profile = true;
      this.save();
    },
    imagepath(e) {
      const file = e.target.files[0];
      console.log(file);
      this.image_path = URL.createObjectURL(file);
    },
    PassportImagePath(e) {
      const file = e.target.files[0];
      this.passport_image_path = URL.createObjectURL(file);
    },
    CDCImagePath(e) {
      const file = e.target.files[0];
      this.cdc_image_path = URL.createObjectURL(file);
    },
    SiDImagePath(e) {
      const file = e.target.files[0];
      this.sid_image_path = URL.createObjectURL(file);
    },
    CocImagePath(e) {
      const file = e.target.files[0];
      this.coc_image_path = URL.createObjectURL(file);
    },
    WatchkeepingImagePath(e) {
      const file = e.target.files[0];
      this.watchkeeping_image_path = URL.createObjectURL(file);
    },
    COPImagePath(e) {
      const file = e.target.files[0];
      this.cop_image_path = URL.createObjectURL(file);
    },
    async handleFileUpload() {
      try {
        console.log(this.form);
        console.log('try uploading');
        this.isLoading = true;
        let userId = this.form.id; // Assuming you have a user ID to associate the uploads
        console.log(userId);

        let formData = new FormData();
        formData.append("id", userId);

        // Handle  image upload
        let generalImageFile = this.$refs.file_0?.files[0];
        if (generalImageFile) {
          formData.append("image_path", generalImageFile);
        }

        // Handle Signature image upload
        let signatureImageFile = this.$refs.file_7?.files[0];
        if (signatureImageFile) {
          formData.append("signature_image_path", signatureImageFile);
        }

        // Handle passport image upload
        let passportImageFile = this.$refs.file_1?.files[0];
        if (passportImageFile) {
          formData.append("passport_image_path", passportImageFile);
        }

        // Handle CDC image upload
        let cdcImageFile = this.$refs.file_2?.files[0];
        if (cdcImageFile) {
          formData.append("cdc_image_path", cdcImageFile);
        }

        // Handle SiD image upload
        let sidImageFile = this.$refs.file_3?.files[0];
        if (sidImageFile) {
          formData.append("sid_image_path", sidImageFile);
        }

        // Handle COC image upload
        let CocImageFile = this.$refs.file_4?.files[0];
        if (CocImageFile) {
          formData.append("coc_image_path", CocImageFile);
        }

        // Handle WatchKeeping image upload
        let watchkeepingImageFile = this.$refs.file_5?.files[0];
        if (watchkeepingImageFile) {
          formData.append("watch_keeping_image_path", watchkeepingImageFile);
        }

        // Handle COP image upload
        let copImageFile = this.$refs.file_6?.files[0];
        if (copImageFile) {
          formData.append("cop_image_path", copImageFile);
        }

        // Make the API call
        await axios.post("user_document_upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.isLoading = false;
      } catch (error) {
        console.error("Error uploading files:", error);
        this.isLoading = false;
      }
    },
  },
  computed: {
    roleName() {
      // Get role name from store or form data
      if (this.form && this.form.roles && this.form.roles.length > 0) {
        return this.form.roles[0].name;
      }
      return '';
    },
    // Whether the LOGGED-IN user (this.user, not the edited candidate) may reset
    // attempts. NOTE: roleName above is the EDITED candidate's role, so we read the
    // logged-in user's role/rank directly. Vessel admins have role CANDIDATE and are
    // identified by rank (VESSEL ADMIN / MASTER).
    canResetAttempts() {
      const u = this.user || {};
      const myRole = (u.roles && u.roles[0] && u.roles[0].name) || "";
      const myRank = u.rank || "";
      const adminRoles = ["SUPER ADMIN", "ADMIN", "MANAGER", "TEACHER", "COMPANY"];
      const adminRanks = ["MASTER", "VESSEL ADMIN"];
      return adminRoles.includes(myRole) || adminRanks.includes(myRank);
    },
    // Same admin/vessel-admin gate as reset — whoever can reset can also mark complete.
    canMarkComplete() {
      return this.canResetAttempts;
    },
    // Whether this candidate has at least one saved, not-completed course that is
    // expired or attempts-exhausted — gates the "Reset All" bulk button.
    hasLockedOutCourses() {
      return (this.courserow || []).some(
        (c) => c.id && this.isLockedOut(c)
      );
    },
  },
};
</script>
